(function () {
  'use strict';

  const component = document.querySelector('.AnnouncementBar__Content');

  if (!component) {
    return;
  }

  const settingScript = document.querySelector('#announcement-bar-free-shipping-countdown-setting');

  if (!settingScript) {
    return;
  }

  const settings = JSON.parse(settingScript.textContent);

  if (!settings.enableCountdown) {
    return;
  }

  const cutoffTime = parseTime(settings.sameDayDeliveryCutoffTime);
  const countdownStartTime = parseTime(settings.countdownStartTime);

  const startTime = new Date();
  startTime.setHours(countdownStartTime.hour, countdownStartTime.minute, 0, 0);

  const endTime = new Date();
  endTime.setHours(cutoffTime.hour, cutoffTime.minute, 0, 0);

  let initialized = false;

  const tickerHour = document.createElement('span');
  tickerHour.classList.add('announcement-bar-free-shipping-countdown-ticker');

  const tickerMinute = document.createElement('span');
  tickerMinute.classList.add('announcement-bar-free-shipping-countdown-ticker');

  const tickerSecond = document.createElement('span');
  tickerSecond.classList.add('announcement-bar-free-shipping-countdown-ticker');

  const intervalId = setInterval(updateTicker, 1000);
  updateTicker();

  function updateTicker() {
    const now = new Date();

    if (now < startTime) {
      clearChildNodes(component);
      component.textContent = settings.messageBeforeStartTime;
      clearInterval(intervalId);
    } else if (endTime - now > 1 * 1000) {
      if (!initialized) {
        clearChildNodes(component);
        component.appendChild(document.createTextNode('Order in the next '));
        component.appendChild(tickerHour);
        component.appendChild(tickerMinute);
        component.appendChild(tickerSecond);
        component.appendChild(document.createTextNode(' to deliver for FREE today'));
        initialized = true;
      }

      const distance = endTime - now;
      const hour = Math.floor(distance % (24 * 60 * 60 * 1000) / (60 * 60 * 1000));
      const minute = Math.floor(distance % (60 * 60 * 1000) / (60 * 1000));
      const second = Math.floor(distance % (60 * 1000) / (1000));
      tickerHour.textContent = hour + 'h';
      tickerMinute.textContent = minute + 'm';
      tickerSecond.textContent = second + 's';
    } else {
      clearChildNodes(component);

      if (now.getHours() == 16){
        component.textContent = "Order by 5 PM to deliver for FREE in KL & Selangor today"
      }else{
        component.textContent = settings.messageAfterCutoffTime;
      }

      clearInterval(intervalId);
    }
  }

  function clearChildNodes(node) {
    while (node.hasChildNodes()) {
      node.removeChild(node.lastChild);
    }
  }

  function parseTime(timeStr) {
    timeStr = timeStr.toUpperCase();

    const tokens = timeStr.split(/[: ]/);

    if (tokens.length !== 3) {
      throw new Error('Invalid time format');
    }

    let hour = parseInt(tokens[0], 10);
    const minute = parseInt(tokens[1], 10);
    const period = tokens[2];

    if (hour < 1 || hour > 12) {
      throw new Error('Invalid time format');
    }

    if (minute < 0 || minute > 59) {
      throw new Error('Invalid time format');
    }

    if (period !== 'AM' && period !== 'PM') {
      throw new Error('Invalid time format');
    }

    if (period === 'PM') {
      if (hour !== 12) {
        hour += 12;
      }
    } else {
      if (hour === 12) {
        hour = 0;
      }
    }

    return { hour, minute };
  }
})();
